<template>
  <div>
    <el-dialog
      left
      title="Update Summary"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="520px"
      style="margin: 0 auto;"
      :visible.sync="isShow"
      @close="handleCancel()"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="summarySave">
        <div class="row">
          <div class="col-6">
            <div class="formLabel">
              Capital Commitment
              <span class="required">*</span>
            </div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%;"
              required
              v-model="value.data.capital_commitment"
              placeholder="Capital Commitment"
              @keyup="calculateDistributionsCarry"
            />
          </div>
          <div class="col-6">
            <div class="formLabel">
              Capital Called
              <span class="required">*</span>
            </div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%;"
              required
              v-model="value.data.capital_called"
              placeholder="Capital Called"
              @keyup="calculateDpi"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="formLabel">
              Last call
              <span class="required">*</span>
            </div>
            <!-- v-model="value.data.last_call" -->
            <input
              type="date"
              class="form-control team-form"
              style="width: 100%;"
              required
              :value="value.data.last_call && moment.utc(value.data.last_call).format('YYYY-MM-DD')?moment.utc(value.data.last_call).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
              @input="value.data.last_call = moment($event.target.valueAsDate)"
              placeholder="Last call"
            />
          </div>
          <div class="col-6">
            <div class="formLabel">Distributions</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%;"
              v-model="value.data.distributions"
              placeholder="Distributions"
              @keyup="calculateMoic"
            />
          </div>
        </div>
        <div class="row pb-2" style="padding-top:15px">
          <div class="col-6 formLabel">Capital Deployed</div>
          <div class="col-6" v-if="value.data.capital_deployed">{{capitalDeployedValue}}</div>
          <div class="col-6" v-else>-</div>
        </div>
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Management fees</div>
          <div class="col-6" v-if="managementFees">{{managementFees}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Carry</div>
          <div class="col-6" v-if="value.data.carry">{{value.data.carry}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <div class="row pb-2">
          <div class="col-6 formLabel">MOIC</div>
          <div class="col-6" v-if="moic">{{moic}}</div>
          <div class="col-6" v-else>-</div>
        </div>
        <div class="row pb-2">
          <div class="col-6 formLabel">TVPI</div>
          <div class="col-6" v-if="value.data.tvpi">{{tvpi}}</div>
          <div class="col-6" v-else>-</div>
        </div>
        <div class="row pb-2">
          <div class="col-6 formLabel">DPI</div>
          <div class="col-6" v-if="dpi">{{dpi}}</div>
          <div class="col-6" v-else>-</div>
        </div>
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">IRR</div>
          <div class="col-6" v-if="value.data.irr">{{value.data.irr}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <div class="edit-company-action-button-row pt-3" style="margin:0px">
          <button
            type="button"
            @click="handleCancel()"
            class="todo-form-cancel-button btn-outline-secondary"
          >Cancel</button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="isSaving"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px;"
          >
            Save
            <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize } from "../../../util";
import { Select, Option } from "element-ui";
import { formatCurrency, formatNumberWithComma } from "../../../util";
import { mapGetters } from "vuex";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      isCreate: Boolean,
      portfolioCost: String,
      portfolioValue: String,
      detailsData: Array,
      summaryData: Object,
    },
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    isShow: {
      get() {
        this.initializeModal();
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    managementFees() {
      return this.formatCurrency(
        this.managementFeeValue,
        this.currency.ref,
        0,
        true
      );
    },
    moic() {
      return this.moicValue;
    },
    dpi() {
      return this.dpiValue;
    },
    moment() {
      return moment;
    },
    capitalDeployedValue() {
      let retval = this.value.data.capital_deployed
        ? formatNumberWithComma(Number(this.value.data.capital_deployed))
        : 0;
      return retval ? `$${retval}` : 0;
    },
    tvpi() {
      return this.tvpiValue;
    },
  },
  data() {
    return {
      isSaving: false,
      managementFeeValue: 0,
      moicValue: 0,
      dpiValue: 0,
      tvpiValue: 0,
    };
  },
  methods: {
    handleCancel() {
      this.isShow = false;
      this.isSaving = false;
    },
    summarySave() {
      const self = this;
      let payload = JSON.parse(JSON.stringify(this.value.data));
      payload.capital_called = payload.capital_called
        ? Number(payload.capital_called)
        : 0;
      payload.distributions = payload.distributions
        ? Number(payload.distributions)
        : 0;
      payload.distributed_to_date += Number(payload.distributions);
      payload.capital_called_to_date += Number(payload.capital_called);
      payload.capital_commitment = Number(payload.capital_commitment);
      payload.capital_deployed = Number(payload.capital_deployed);
      payload.dpi = Number(payload.dpi);
      payload.tvpi = Number(payload.tvpi);
      payload.moic = Number(payload.moic);
      //payload.management_fees = Number(payload.management_fees);
      if (payload.distributed_to_date > payload.capital_commitment) {
        payload.distributions_exceed_to_date = payload.hasOwnProperty(
          "distributions_exceed_to_date"
        )
          ? Number(payload.distributions_exceed_to_date) + 1
          : 1;
      } else {
        payload.distributions_exceed_to_date = 0;
      }
      payload.distributions_exceed_to_date = Number(
        payload.distributions_exceed_to_date
      );
      payload.current_call = payload.hasOwnProperty("current_call")
        ? Number(payload.current_call) + 1
        : 1;
      payload.last_call = payload.last_call
        ? new Date(payload.last_call)
        : new Date();
      payload.distributions_in_carry = Number(payload.distributions_in_carry);
      payload.distributions_pre_carry = Number(payload.distributions_pre_carry);
      self.isSaving = true;
      self.$store
        .dispatch("lpAllocations/apiPostSummaryData", payload)
        .then((user) => {
          let summaryData = self.$store.getters["lpAllocations/summaryData"];
          self.value.summaryData =
            summaryData && summaryData.length > 0 ? summaryData[0] : {};
          self.value.detailsData =
            self.$store.getters["lpAllocations/detailsData"];
          if (self.value.detailsData && self.value.detailsData.length == 0) {
            self
              .addGpCarry(self.value.summaryData)
              .then((data) => {
                self.$emit("emit-success");
                self.handleCancel();
                self.$toaster.success("Saved Successfully.");
              })
              .catch((error) => {
                console.log("error in add gp carry from summary", error);
                this.isSaving = false;
                this.$toaster.error("Fail to update Summary Data");
              });
          } else {
            self
              .updateLpDetails()
              .then((data) => {
                self
                  .updateSummaryDetails(self.value.summaryData)
                  .then((response) => {
                    self.$emit("emit-success");
                    self.handleCancel();
                    self.$toaster.success("Saved Successfully.");
                  })
                  .catch((error) => {
                    console.log("error in update summary from summary", error);
                    this.isSaving = false;
                    this.$toaster.error("Fail to update Summary Data");
                  });
              })
              .catch((error) => {
                console.log("error in bulk details update from summary", error);
                this.isSaving = false;
                this.$toaster.error("Fail to update Summary Data");
              });
          }
        })
        .catch((err) => {
          this.isSaving = false;
          this.$toaster.error("Fail to update Summary Data");
        });
    },
    formatCurrency: formatCurrency,
    calculateManagementFees() {
      if (this.value.data && this.value.data.capital_commitment) {
        let capital_commitment = Number(this.value.data.capital_commitment);
        this.value.data.management_fees = capital_commitment
          ? (2 / 100) * capital_commitment
          : 0;
        this.managementFeeValue = this.value.data.management_fees;
      }
    },
    initializeModal() {
      this.managementFeeValue = this.value.data.management_fees;
      this.moicValue = this.value.data.moic;
      this.dpiValue = this.value.data.dpi;
      this.tvpiValue = this.value.data.tvpi;
    },
    calculateMoic() {
      // let distributed_to_date = this.value.data.distributed_to_date;
      // if (this.value.data && this.value.data.distributions) {
      //   distributed_to_date += Number(this.value.data.distributions);
      // }
      // this.value.data.moic =
      //   this.value.data.capital_deployed &&
      //   Number(this.value.data.capital_deployed) > 0
      //     ? (
      //         Number(
      //           Number(distributed_to_date) -
      //             Number(this.value.data.capital_deployed)
      //         ) / Number(this.value.data.capital_deployed)
      //       ).toFixed(2)
      //     : 0;
      this.value.data.moic =
        this.value.data.capital_deployed &&
        Number(this.value.data.capital_deployed) > 0 &&
        this.value.portfolioValue &&
        Number(this.value.portfolioValue) > 0
          ? Number(
              (
                Number(this.value.portfolioValue) /
                Number(this.value.data.capital_deployed)
              ).toFixed(2)
            )
          : 0;
      this.moicValue = this.value.data.moic;
      this.calculateDpi();
    },
    calculateDpi() {
      let distributionToDate = this.value.data.distributed_to_date;
      let capitalCalledToDate = this.value.data.capital_called_to_date;
      if (this.value.data && this.value.data.distributions) {
        distributionToDate += Number(this.value.data.distributions);
      }
      if (this.value.data && this.value.data.capital_called) {
        capitalCalledToDate += Number(this.value.data.capital_called);
      }
      this.value.data.tvpi =
        this.value.portfolioValue &&
        Number(this.value.portfolioValue) > 0 &&
        Number(capitalCalledToDate) > 0
          ? Number(
              (
                Number(this.value.portfolioValue) / Number(capitalCalledToDate)
              ).toFixed(2)
            )
          : 0;
      this.tvpiValue = this.value.data.tvpi;
      let lpDistributionsSum = 0;
      let totalLpOwnership = 0;
      if (
        this.value.data.detailsData &&
        this.value.data.detailsData.length > 0
      ) {
        this.value.data.detailsData.map((item) => {
          if (
            item &&
            item.hasOwnProperty("ownership") &&
            Number(item.ownership) > 0
          ) {
            totalLpOwnership += Number(item.ownership);
          }
          if (
            item &&
            item.hasOwnProperty("distributions") &&
            Number(item.distributions) > 0
          ) {
            lpDistributionsSum += Number(item.distributions);
          }
        });
      }
      // this.value.data.dpi =
      //   Number(distributionToDate) > 0 && Number(capitalCalledToDate) > 0
      //     ? (Number(distributionToDate) / Number(capitalCalledToDate)).toFixed(
      //         2
      //       )
      //     : 0;
      this.value.data.dpi =
        Number(lpDistributionsSum) > 0 &&
        Number(capitalCalledToDate) > 0 &&
        Number(totalLpOwnership) > 0
          ? (
              Number(lpDistributionsSum) /
              (Number(capitalCalledToDate) * (Number(totalLpOwnership) / 100))
            ).toFixed(2)
          : 0;
      this.dpiValue = this.value.data.dpi;
      this.calculateDistributionsCarry();
    },
    updateLpDetails() {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (self.value.detailsData && self.value.detailsData.length > 0) {
          let ownershipLoopValues = 0;
          let gpOwnershipLoopValues = 0;
          this.value.detailsData.map((item) => {
            if (
              item.hasOwnProperty("ownership") &&
              Number(item.ownership) > 0
            ) {
              if (item.entity_type == "LP") {
                ownershipLoopValues += Number(item.ownership);
              } else {
                if (item.entity_type == "GP") {
                  gpOwnershipLoopValues += Number(item.ownership);
                }
              }
            }
          });
          self.value.detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership) > 0
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit) > 0
                ? Number(item.profit)
                : 0;
            if (item.hasOwnProperty("capital_commitment")) {
              let capitalCommitment =
                this.value.summaryData &&
                this.value.summaryData.hasOwnProperty("capital_commitment") &&
                Number(this.value.summaryData.capital_commitment) > 0
                  ? Number(this.value.summaryData.capital_commitment)
                  : 0;
              item.capital_commitment = Number(
                (Number(ownership / 100) * Number(capitalCommitment)).toFixed(2)
              );
            }
            if (item.hasOwnProperty("capital_called")) {
              item.capital_called =
                ownership &&
                this.value.summaryData &&
                this.value.summaryData.hasOwnProperty("capital_called") &&
                Number(this.value.summaryData.capital_called) > 0
                  ? Number(
                      (
                        Number(ownership / 100) *
                        Number(this.value.summaryData.capital_called)
                      ).toFixed(2)
                    )
                  : 0;
              item.capital_called_to_date = item.hasOwnProperty(
                "capital_called_to_date"
              )
                ? Number(item.capital_called_to_date) +
                  Number(item.capital_called)
                : Number(item.capital_called);
            }
            if (item.hasOwnProperty("contributed_to_date")) {
              let contributedToDate =
                item.hasOwnProperty("contributed_to_date") &&
                Number(item.contributed_to_date) > 0
                  ? Number(item.contributed_to_date)
                  : 0;
              let openBalance =
                item.hasOwnProperty("open_balance") &&
                Number(item.open_balance) > 0
                  ? Number(item.open_balance)
                  : 0;
              let capitalCalled =
                item.hasOwnProperty("capital_called") &&
                Number(item.capital_called) > 0
                  ? Number(item.capital_called)
                  : 0;
              item.contributed_to_date = Number(
                (
                  Number(contributedToDate) +
                  (Number(capitalCalled) - Number(openBalance))
                ).toFixed(2)
              );
            }
            if (item.hasOwnProperty("remaining_commitment")) {
              let capitalCommitment =
                item.hasOwnProperty("capital_commitment") &&
                Number(item.capital_commitment) > 0
                  ? Number(item.capital_commitment)
                  : 0;
              let contributedToDate =
                item.hasOwnProperty("contributed_to_date") &&
                Number(item.contributed_to_date) > 0
                  ? Number(item.contributed_to_date)
                  : 0;
              item.remaining_commitment = Number(
                (Number(capitalCommitment) - Number(contributedToDate)).toFixed(
                  2
                )
              );
            }
            if (item.hasOwnProperty("lp_summary_id")) {
              if (this.value.summaryData && this.value.summaryData._id) {
                item.lp_summary_id = this.value.summaryData._id;
              }
            }
            if (
              item.hasOwnProperty("share_of_fees") &&
              item.hasOwnProperty("entity_type")
            ) {
              if (item.entity_type == "LP") {
                if (
                  this.value.summaryData &&
                  this.value.summaryData.hasOwnProperty("current_call") &&
                  this.value.summaryData.current_call == 1
                ) {
                  item.share_of_fees =
                    this.value.summaryData.hasOwnProperty("management_fees") &&
                    Number(this.value.summaryData.management_fees) > 0
                      ? Number(
                          (
                            (Number(ownership) / Number(ownershipLoopValues)) *
                            Number(this.value.summaryData.management_fees)
                          ).toFixed(2)
                        )
                      : 0;
                } else {
                  item.share_of_fees = 0;
                }
              } else {
                item.share_of_fees = 0;
              }
            }
            if (
              item.hasOwnProperty("entity_type") &&
              item.hasOwnProperty("distributions") &&
              item.hasOwnProperty("ownership")
            ) {
              if (
                this.value.summaryData &&
                this.value.summaryData.hasOwnProperty("distributions") &&
                Number(this.value.summaryData.distributions) > 0 &&
                Number(this.value.summaryData.distributions_pre_carry) &&
                Number(this.value.summaryData.distributions_in_carry)
              ) {
                if (
                  this.value.summaryData.hasOwnProperty(
                    "distributed_to_date"
                  ) &&
                  this.value.summaryData.hasOwnProperty("capital_commitment") &&
                  Number(this.value.summaryData.distributed_to_date) >
                    Number(this.value.summaryData.capital_commitment)
                ) {
                  item.distributions = Number(
                    (
                      Number(this.value.summaryData.distributions_pre_carry) *
                        (Number(ownership) / 100) +
                      Number(this.value.summaryData.distributions_in_carry) *
                        (Number(profit) / 100)
                    ).toFixed(2)
                  );
                } else {
                  item.distributions =
                    item.entity_type == "LP" || item.entity_type == "GP"
                      ? Number(
                          (
                            Number(
                              this.value.summaryData.distributions_pre_carry
                            ) *
                              (Number(ownership) / 100) +
                            Number(
                              this.value.summaryData.distributions_in_carry
                            ) *
                              (Number(profit) / 100)
                          ).toFixed(2)
                        )
                      : 0;
                }
              }
            }
            if (
              item.hasOwnProperty("lp_percentage") &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP"
            ) {
              item.lp_percentage =
                Number(ownership) > 0
                  ? Number(
                      (
                        (Number(ownership) / Number(ownershipLoopValues)) *
                        100
                      ).toFixed(2)
                    )
                  : 0;
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    formatNumberWithComma: formatNumberWithComma,
    calculateDistributionsCarry() {
      let distributionToDate = this.value.data.distributed_to_date
        ? Number(this.value.data.distributed_to_date)
        : 0;
      if (this.value.data && this.value.data.distributions) {
        distributionToDate += Number(this.value.data.distributions);
      }
      this.value.data.distributions_in_carry =
        Number(distributionToDate) - Number(this.value.data.capital_commitment);
      this.value.data.distributions_pre_carry =
        Number(distributionToDate) -
        Number(this.value.data.distributions_in_carry);
    },
    addGpCarry(summaryData) {
      const self = this;
      let serverData = {};
      return new Promise((resolve, reject) => {
        serverData.entity_name = "Carry";
        serverData.entity_type = "GP Carry";
        serverData.ownership = 0;
        serverData.distributions = 0;
        serverData.profit = 20;
        serverData.lp_percentage = 0;
        if (summaryData.hasOwnProperty("_id")) {
          serverData.lp_summary_id = summaryData._id;
        }
        self.$store
          .dispatch("lpAllocations/apiPostDetailsData", serverData)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateSummaryDetails(summaryData) {
      const self = this;
      return new Promise((resolve, reject) => {
        let serverData = summaryData;
        if (
          serverData &&
          serverData.hasOwnProperty("_id") &&
          serverData._id.length > 0
        ) {
          let ContributedToDate = 0;
          if (self.value.detailsData && self.value.detailsData.length > 0) {
            self.value.detailsData.map((item) => {
              if (
                item &&
                item.hasOwnProperty("entity_type") &&
                item.entity_type == "LP"
              ) {
                if (
                  item.hasOwnProperty("contributed_to_date") &&
                  Number(item.contributed_to_date) > 0
                ) {
                  ContributedToDate += Number(item.contributed_to_date);
                }
              }
            });
            serverData.capital_deployed = ContributedToDate;
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
  },
  mounted() {},
};
</script>
<style>
</style>